import(/* webpackMode: "eager" */ "/home/runner/work/bookingo_v2/bookingo_v2/admin/src/app/not-found.tsx")